export enum loggedValues {
    SHEETS = 'sheets',
    LOGGED = 'logged',
    NOLOGGED = 'nologged'
};